import ReactDOM from 'react-dom/client';
import React from 'react';
import { PricingTab } from './pricing-tab';
import { ToastContainer } from 'react-toastify';
import { TenantContext } from '../../context/tenant-context';
import 'react-toastify/dist/ReactToastify.css';
import { v2Component } from '../../index';

export function initPricingTab() {
  document.getElementsByName('pricing-tab').forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);
      const { tenant, contextPath, productId, forRent, forSale, ...props } = Object.assign({}, element.dataset) as any;
      root.render(
        v2Component(
          <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
            <ToastContainer />
            <PricingTab
              productId={parseInt(productId)}
              forRent={forRent === 'true'}
              forSale={forSale === 'true'}
              {...props}
            />
          </TenantContext.Provider>,
        ),
      );

      const event = new CustomEvent('change');
      element.dispatchEvent(event);
    }
  });
}
